// extracted by mini-css-extract-plugin
export default {"document":"MissingDoc_document__5T-ZZ"};